import type { JobAdsResult } from "@/modules/jobAds/client/api/types"
import type { FunctionComponent, PropsWithChildren } from "react"

import { useEffect } from "react"

import { useJobAdsClientTracking } from "@/modules/jobAds/client/hooks/useJobAdsClientTracking"

type TrackerProps = PropsWithChildren<{
  algoliaSearchId: JobAdsResult["searchId"]
  nbResults: JobAdsResult["totalSize"]
}>

export const Tracker: FunctionComponent<TrackerProps> = ({ algoliaSearchId, children, nbResults }) => {
  const { trackJobAdsSearch } = useJobAdsClientTracking()

  useEffect(() => {
    trackJobAdsSearch({ algoliaSearchId, nbResults })
  }, [algoliaSearchId, nbResults, trackJobAdsSearch])

  return children
}
